export enum BloodTypesEnum {
    OP = "o_pos",
    ON = "o_neg",
    AP = "a_pos",
    AN = "a_neg",
    BP = "b_pos",
    BN = "b_neg",
    ABP = "ab_pos",
    ABN = "ab_neg",
}
